<script>
    // Icons ordered so the initial display reads [bike, run, swim] left-to-right.
    // The sequence entering from the left each loop is bike → swim → run → bike → …
    // which with the (n+2)/(n+1) shift formula produces [bike, run, swim] at n=0.
    const allIcons = ['fa-person-biking', 'fa-person-swimming', 'fa-person-running'];
    let n = 0;

    // At each animationiteration on i1, advance n so icons shift one position to the right.
    function onIteration() {
        n = (n + 1) % allIcons.length;
    }

    // Derived positions. Formula ensures i2/i3/i4 at the start of loop n+1 show the
    // same icons that i1/i2/i3 showed at the END of loop n — seamless hand-off.
    $: i1 = allIcons[n % 3];
    $: i2 = allIcons[(n + 2) % 3];
    $: i3 = allIcons[(n + 1) % 3];
    $: i4 = allIcons[n % 3];
</script>

<div class="lds-ellipsis m-auto">
    <i class="fa-solid {i1}" on:animationiteration={onIteration}></i>
    <i class="fa-solid {i2}"></i>
    <i class="fa-solid {i3}"></i>
    <i class="fa-solid {i4}"></i>
</div>

<style lang="scss">
    .lds-ellipsis {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 13px;
    }
    .lds-ellipsis i {
        position: absolute;
        width: 13px;
        height: 13px;
        font-size: 13px;
        color: #D8D8D8;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis i:nth-child(1) {
        left: 8px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis i:nth-child(2) {
        left: 8px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis i:nth-child(3) {
        left: 32px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis i:nth-child(4) {
        left: 56px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(24px, 0);
        }
    }
</style>
